
const parentInfo = {
  namespaced: true,
  state: {
    childList: [],//所有孩子
    allChildList: [],//切换子女
    childData: {},//当前孩子信息
    chatIndex: -1,
    msgList: [],
    detailsData: {},
    userInfo: {},//家长信息
    signData: {},
    moduleData: ''
  },
  mutations: {
    getDetailsData(state, childList) {
      state.detailsData = childList
    },
    addChildList(state, childList) {
      state.childList = childList
    },
    changeChildInfo(state, childList) {
      state.allChildList = childList
    },
    addChildData(state, info) {
      state.childData = info
    },
    changeChatIndex(state, i) {
      state.chatIndex = i
    },
    changeMsgList(state, msgList) {
      state.msgList = msgList
    },
    addUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    addSignState(state, signState) {
      state.signData = signState
    },
    changeModuleData(state, data) {
      state.moduleData = data
    },
    resetState(state) {
      state.childList = [];//所有孩子
      state.allChildList = [];//切换子女
      state.childData = '';//当前孩子信息
      state.chatIndex = -1;
      state.msgList = [];
      state.detailsData = {};
      state.userInfo = {};//家长信息
      state.signData = {};
      state.moduleData = '';
    },
  }
}
export default parentInfo